"use client";

import { Heading, Text } from "@pamperedchef/design-system";
import type { BlockOf } from "@/domain/catalog";
import { Stub } from "@/composites/_internal";

/**
 * Adapter for the `upsell_set_block` — Figma section **"Get even more with
 * the set"**. Renders the CMS-authored intro headline + body and a labelled
 * placeholder for the set-products grid (`block.set_skus`).
 *
 * Real product-card grid lands in a follow-on ticket; this file owns the
 * section-heading + intro-copy shell so the PDP layout reads correctly with
 * fixture data today.
 */
export function UpsellSet({ block }: { block: BlockOf<"upsell_set_block"> }) {
	return (
		<section data-block="upsell_set_block">
			<Heading tag="h2">{block.intro_headline}</Heading>
			{block.intro_body ? (
				<Text tag="p" styledAs="mdr">
					{block.intro_body}
				</Text>
			) : null}
			<Stub
				name="features/product-detail/blocks/UpsellSet"
				intent="Product-set grid pending: render `block.set_skus` as a ProductCard row."
			>
				<code>
					set_skus: {block.set_skus.map((s) => s.sku).join(", ")}
				</code>
			</Stub>
		</section>
	);
}
